module.exports = __webpack_public_path__ + "static/media/economistgroup.26ffa540.svg";